import { render, staticRenderFns } from "./SectorList.vue?vue&type=template&id=dcecf2da&"
import script from "./SectorList.vue?vue&type=script&lang=js&"
export * from "./SectorList.vue?vue&type=script&lang=js&"
import style0 from "./SectorList.vue?vue&type=style&index=0&id=dcecf2da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports